import { render, staticRenderFns } from "./CompanyCtepRegister.vue?vue&type=template&id=5752152a&scoped=true&"
import script from "./CompanyCtepRegister.vue?vue&type=script&lang=ts&"
export * from "./CompanyCtepRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752152a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5752152a')) {
      api.createRecord('5752152a', component.options)
    } else {
      api.reload('5752152a', component.options)
    }
    module.hot.accept("./CompanyCtepRegister.vue?vue&type=template&id=5752152a&scoped=true&", function () {
      api.rerender('5752152a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyCtepRegister.vue"
export default component.exports